import React from 'react';
import useMemo from '@/util/hook/useMemo';
import { BUTTON_SIZE } from '@/config/ui/button';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
import { BackButton, ForwardButton } from '../../component/atom/Button';
import Description from '../../component/atom/Description';
import Header from '../../component/atom/Header';
import { Check } from '../../component/atom/Icon';
import RWDPageLayout from '../../component/composite/RWDPageLayout';
import { S } from './style';
import { APP } from '../../config/app';
import { CONTRACT } from '../../config/contract';
const renderHeader = () => (<Header progress={APP.PAGE_PROGRESS_INFO['/contract'].progress} progressTitle={APP.PAGE_PROGRESS_INFO['/contract'].title}/>);
const renderDescription = () => (<Description content='此為保障家屬、照服員以及平台三方所擬定的合約。'/>);
const renderContractSection = () => (<S.LayoutContract>
    <S.Contract>
      <h2>{CONTRACT.COMPANY}</h2>
      <div>{CONTRACT.NAME}</div>
      <S.HighlightText>{CONTRACT.LAST_UPDATED_AT}</S.HighlightText>
      {CONTRACT.TERMS.map((term) => (<React.Fragment key={term.title}>
          <p>{term.title}</p>
          <ol>
            {term.list.map((item) => (<li key={item}>{item}</li>))}
          </ol>
        </React.Fragment>))}
      {CONTRACT.FOOTER}
    </S.Contract>
  </S.LayoutContract>);
const renderCheckboxSection = ({ isChecked, handleCheckboxChange, }) => (<S.LayoutCheckboxSection>
    <S.LayoutCheckbox htmlFor='contract'>
      <S.Checkbox>
        {isChecked ? <Check color={SEMANTIC_COLORS.PRIMARY_ICON} size='16px'/> : null}
      </S.Checkbox>
      我已閱讀並同意以上內容
      <S.InputHidden id='contract' type='checkbox' checked={isChecked} onChange={handleCheckboxChange}/>
    </S.LayoutCheckbox>
  </S.LayoutCheckboxSection>);
const renderFooter = ({ isChecked, handleBackButtonClick, handleForwardButtonClick, }) => (<S.LayoutFooter>
    <BackButton size={BUTTON_SIZE.LARGE} isAvailable onButtonClick={handleBackButtonClick}>
      上一步
    </BackButton>
    <S.GapRow width={40}/>
    <ForwardButton size={BUTTON_SIZE.LARGE} isAvailable={isChecked} onButtonClick={handleForwardButtonClick}>
      確認
    </ForwardButton>
  </S.LayoutFooter>);
export default function View({ 
// data
isLoading, isChecked, pageHeight, 
// func
handleCheckboxChange, handleBackButtonClick, handleForwardButtonClick, }) {
    const header = useMemo(() => renderHeader(), []);
    const description = useMemo(() => renderDescription(), []);
    const contractSection = useMemo(() => renderContractSection(), []);
    const checkboxSection = useMemo(() => renderCheckboxSection({ isChecked, handleCheckboxChange }), [isChecked, handleCheckboxChange]);
    const footer = useMemo(() => renderFooter({ isChecked, handleBackButtonClick, handleForwardButtonClick }), [isChecked, handleBackButtonClick, handleForwardButtonClick]);
    return (<RWDPageLayout isLoading={isLoading}>
      {header}
      <S.Layout pageHeight={pageHeight}>
        {description}
        {contractSection}
        {checkboxSection}
        {footer}
      </S.Layout>
    </RWDPageLayout>);
}
